import {
  ApplicationConfig,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { routes } from './app.routes';
import { noCacheInterceptor } from './interceptors/no-cache.interceptor';
import { tokenInterceptor } from './interceptors/token.interceptor';
import { initializeToken } from './utils/app-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([noCacheInterceptor, tokenInterceptor]),
    ),
    provideAppInitializer(initializeToken),
  ],
};
